import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {SeoService} from '../../services/seo.service';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser';

import  { Partner } from '../../models/partner.model';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent implements OnInit{

  public partners:Array<Partner>;

  public items = [];


  constructor( private title: Title, private seo: SeoService, private sanitizer: DomSanitizer ) {
    this.items = [
      {
        img: './assets/img/cryptmi/item-press-22.png',
        date: 'Oct 19, 2020',
        title: 'Turning Loyalty Points Into Digital Currency For Latin American Consumers',
        description: 'When performing at their highest and best level, the various rewards points offerings designed by card issuers can be very sticky engagement tools for consumers',
        link: 'https://www.pymnts.com/news/loyalty-and-rewards-news/2020/visa-novae-loyalty-points-digital-currency-latam/',
        delay: '100ms'
      },
      {
        img: './assets/img/cryptmi/item-press-1.png',
        date: 'Oct 01, 2020',
        title: 'Enhanced Visa Loyalty Solutions Allows for Redemption of Points on Everyday Purchases online or in-store, even contactless',
        description: 'In partnership with novae, Visa Loyalty Solution unveils My Rewards 2.0, a first-of-its-kind offering in Latin America and the Caribbean, turning loyalty points into digital currency that consumers can instantly redeem to shop anywhere, anytime.',
        link: 'https://bm.visa.com/about-visa/newsroom/press-releases/visa-loyalty-solutions-news.html',
        delay: '100ms'
      },
      {
        img: './assets/img/cryptmi/item-press-2.png',
        date: 'Oct 01, 2020',
        title: 'Visa, Novae Relaunch My Rewards 2.0 As Digital Currency Based On Loyalty Points, Miles',
        description: 'Visa and FinTech partner Novae have unveiled their revamped rewards program, dubbed My Rewards 2.0, with which loyalty points and miles can be “spent” at over 60 million merchants.',
        link: 'https://www.pymnts.com/news/loyalty-and-rewards-news/2020/visa-novae-relaunch-rewards-program-loyalty-points',
        delay: '200ms'
      },
      {
        img: './assets/img/cryptmi/item-press-23.png',
        date: 'Apr 28, 2020',
        title: 'LifeMiles Introduces Innovative "Miles Care" in Partnership with FinTech and InsurTech Company, novae',
        description: "LifeMiles, Latin America's leading airline driven loyalty program, announced a partnership with FinTech and InsurTech company novae to delight their users with an unparalleled travel experience.",
        link: 'https://www.prnewswire.com/news-releases/lifemiles-introduces-innovative-miles-care-in-partnership-with-fintech-and-insurtech-company-novae-301048492.html',
        delay: '200ms'
      },
  		{
  			img: './assets/img/cryptmi/itempress-2.png',
  			date: 'Sep 04, 2019',
  			title: 'novae leverages Expedia Partner Solutions to further enhance travel booking',
  			description: 'Expanded travel options, a more engaging digital experience, unique trip protections and other benefits consolidate alle as the digital engagement experience of choice for merchant loyalty programs',
  			link: 'https://www.prnewswire.com/news-releases/novae-leverages-expedia-partner-solutions-to-further-enhance-travel-booking-payment-and-protections-on-its-alle-white-label-digital-loyalty-platform-300911492.html?tc=eml_cleartime',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-3.png',
  			date: 'Mar 12, 2019',
  			title: 'Onboard, a mobile platform that allows bank cardholders to activate and visualize',
  			description: 'The fintech and insurtech company novae has launched Onboard, an all-digital platform that allows bank cardholders to access all their card-related benefits by simply downloading the app and entering the first six digits of their cards.',
  			link: 'https://www.prnewswire.com/news-releases/onboard-a-mobile-platform-that-allows-bank-cardholders-to-activate-and-visualize-their-card-benefits-on-their-personal-device-now-comes-automatically-through-novaes-mobile-white-label-digital-solution-300811189.html?tc=eml_cleartime',
  		  delay: '100ms'
      },
  		{
  			img: './assets/img/cryptmi/itempress-4.png',
  			date: 'Feb 22, 2019',
  			title: "Trinidad & Tobago's First Citizens Group Becomes Visa Loyalty Solutions Premium Partner",
  			description: 'Trinidad-based First Citizens Group has received the Premium Partner designation from fintech and insurtech company novae and leading payment technology company Visa for being one of the first banks in the Caribbean to adopt Visa Loyalty Solutions (VLS), the white-label digital loyalty platform the two companies recently co-created.',
  			link: 'https://www.prnewswire.com/news-releases/trinidad-amp-tobago-s-first-citizens-group-becomes-visa-loyalty-solutions-premium-partner-886564428.html',
        delay: '200ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-5.png',
  			date: 'Nov 13, 2019',
  			title: "LAFISE Group (LAFISE) taps FinTech and InsurTech company novae as digital transformation partner",
  			description: 'LAFISE Group is one of the first financial groups in the world to implement Visa Loyalty Solutions, a cutting-edge digital payment platform and loyalty program co-created by novae and Visa, as a first step toward its digital transformation',
  			link: 'https://www.prnewswire.com/news-releases/fintech-and-insurtech-company-novae-launches-the-disruptive-digital-capability-framework-dcf-alle2020-a-global-white-label-b2b2c-solution-300734878.html',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-6.png',
  			date: 'Oct 22, 2019',
  			title: "FinTech and InsurTech company novae launches the disruptive Digital Capability Framework (DCF)",
  			description: "The global FinTech and InsurTech company novae has launched the disruptive Digital Capability Framework (DCF) alle2020, a global white-label B2B2C solution leveraging invisible payments, digital currency, contactless accessibility, embedded benefits and push payments. novae unveiled the solution during Nexthon One, its first biannual disruption event, which gathered a select group of forward-thinkers from Google, Visa, Canopius Syndicate at Lloyd's and other leading companies.",
  			link: 'https://www.prnewswire.com/news-releases/visa-launches-visa-loyalty-solutions-the-first-100-digital-loyalty-platform-in-latin-america-and-the-caribbean-300678123.html',
        delay: '100ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-7.png',
  			date: 'Jul 10, 2018',
  			title: "Visa launches Visa Loyalty Solutions, the first 100% digital loyalty platform in Latin America and the Caribbean",
  			description: "In partnership with novae, Visa Loyalty Solutions has made it easier than ever to earn and redeem points with Visa, enabling consumers to exchange loyalty points anytime, anywhere and from any device.",
  			link: 'https://www.prnewswire.com/news-releases/visa-launches-visa-loyalty-solutions-the-first-100-digital-loyalty-platform-in-latin-america-and-the-caribbean-300678123.html',
        delay: '200ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-8.png',
  			date: 'Jul 25, 2018',
  			title: "FinTech and InsurTech disruptor novae launches cross-border, all-digital, mobile-first, white-label loyalty platform",
  			description: "Global FinTech and InsurTech disruptor novae has launched novaeplatform, a user-centric, universal, cross-border, all-digital, mobile-first, white-label loyalty platform for banks that enables consumers and merchants to redeem points anytime, anywhere (online, in-store and while traveling), from any device (mobile, desktop or wearable) and using any payment method (credit, debit, points or split payment).",
  			link: 'https://www.einpresswire.com/article/456134653/fintech-and-insurtech-disruptor-novae-launches-cross-border-all-digital-mobile-first-white-label-loyalty-platform',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-9.png',
  			date: 'Feb 04, 2019',
  			title: "Argentina's Banco Columbia chooses fintech and insurtech company novae as digital transformation partner",
  			description: "Banco Columbia is one of the first banks in Argentina to implement Visa Loyalty Solutions, a cutting-edge digital payment platform and loyalty program co-created by novae and Visa, as a first step toward its digital transformation",
  			link: 'https://www.prnewswire.com/news-releases/argentinas-banco-columbia-chooses-fintech-and-insurtech-company-novae-as-digital-transformation-partner-300789398.html?tc=eml_cleartime',
        delay: '100ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-10.png',
  			date: 'Nov 28, 2018',
  			title: "FinTech and InsurTech company novae teams up with digital technology agency AAXIS to bolster its ecommerce, machine learning and AI capabilities",
  			description: "The partnership will strengthen novae's digital capability framework alle2020, which leverages invisible payments, digital currency, contactless accessibility, embedded benefits and push payments",
  			link: 'https://www.prnewswire.com/news-releases/fintech-and-insurtech-company-novae-teams-up-with-digital-technology-agency-aaxis-to-bolster-its-ecommerce-machine-learning-and-ai-capabilities-300756334.html?tc=eml_cleartime',
        delay: '200ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-11.png',
  			date: 'Nov 27, 2018',
  			title: "Visa rolls out digital loyalty platform in Latin America and Caribbean",
  			description: "Visa has launched its Loyalty Solutions platform for all issuing banks in Latin America and the Caribbean (LAC) to enable redemption of digital points for customers.",
  			link: 'https://www.verdict.co.uk/cards-international/news/visa-loyalty-solutions-platform-latin-america-caribbean/',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-12.png',
  			date: 'Jul 31, 2018',
  			title: "Visa offers Latin American banks rewards built on open tech initiative",
  			description: "Visa has partnered with U.S.-based fintech novae to launch an omnichannel digital rewards platform for Visa card-issuing banks in Latin America and the Caribbean (LAC). The collaboration with San Francisco-based novae is an example of the card network's open approach to fintech.",
  			link: 'https://www.paymentssource.com/news/visa-offers-latin-american-banks-rewards-built-on-open-tech-initiative',
        delay: '100ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-13.png',
  			date: 'Oct 08, 2018',
  			title: "Novae Launches a Universal Loyalty Platform",
  			description: "The American FinTech Novae has a strategic partnership in place with Visa and, in this context, built a white-label customer loyalty and CRM solution. This universal, cross-border platform is intended for banking players and merchants.",
  			link: 'https://adn-co.news/en/articles/details/novae-launches-a-universal-loyalty-platform',
        delay: '200ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-14.png',
  			date: 'Aug 02, 2018',
  			title: "Novae releases mobile-first, white-label loyalty platform for banks",
  			description: "Global FinTech and InsurTech disruptor novae has launched novaeplatform, a user-centric, universal, cross-border, all-digital, mobile-first, white-label loyalty platform for banks that enables consumers to redeem points anytime, anywhere (online, in-store and while traveling), from any device (mobile, desktop or wearable) and using any payment method (credit, debit, points or split payment).",
  			link: 'https://www.finextra.com/pressarticle/74959/novae-releases-mobile-first-white-label-loyalty-platform-for-banks/payments',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-15.png',
  			date: 'Nov 14, 2018',
  			title: "Financial Solutions Provider LAFISE Group Selects Fintech & Insurtech novae As Digital Transformation Partner",
  			description: "LAFISE Group (LAFISE), a Latin American financial services provider, announced on Tuesday it has selected fintech and insurtech company novae to support its digital transformation.",
  			link: 'https://insurtechnews.com/aggregator/financial-solutions-provider-lafise-group-selects-fintech-insurtech-novae-as-digital-transformation-partner?n=b0e6209267b045a07536ecdb14528eeacb786713&u=code-web',
        delay: '100ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-16.png',
  			date: 'Jul 11, 2018',
  			title: "Visa brings digital loyalty program to partner banks in Latin America, Caribbean",
  			description: "Visa has launched Visa Loyalty Solutions, a digital points redemption platform available to all issuing banks in Latin America and the Caribbean, according to a press release.",
  			link: 'https://www.mobilepaymentstoday.com/news/visa-brings-digital-loyalty-program-to-partner-banks-in-latin-america-caribbean/',
        delay: '200ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-17.png',
  			date: 'Jul 11, 2018',
  			title: "Visa Launches Omni Loyalty Platform; Alibaba Kicks Off ‘Malaysia Week’",
  			description: "Consumers in Sweden and Norway are more likely to take out a loan this summer than borrowers in Finland, according to a press release from Tieto. While 22 percent of Swedes and 21 percent of Norwegians are seeking to borrow money, only 14 percent of Finns are looking for summer loans.",
  			link: 'https://www.pymnts.com/news/international/global-payments/2018/visa-omni-loyalty-platform-alibaba-malaysia-week/',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-18.png',
  			date: 'Jul 10, 2018',
  			title: "Visa starts digital loyalty program in Latin America and the Caribbean",
  			description: "Visa (V +0.3%) starts Visa Loyalty Solutions, an ominchannel digital points redemption platform available to issuing banks in Latin America and the Caribbean.",
  			link: 'https://seekingalpha.com/news/3368922-visa-starts-digital-loyalty-program-in-latin-america-and-caribbean',
        delay: '100ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-19.png',
  			date: 'Jul 10, 2018',
  			title: "Visa brings digital loyalty to Latam & Caribbean banks",
  			description: "This weeks’ announcement that Visa had launched a new, all-digital loyalty platform for its Latin American and Caribbean bank partners could have been just another blip on the continuum of interesting fintech developments – there are a lot of them these days.  But I think this announcement bears some examination.",
  			link: 'https://www.thewisemarketer.com/cards-payments/visa-brings-digital-loyalty-to-latam-caribbean-banks/',
        delay: '200ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-20.png',
  			date: 'Jul 10, 2018',
  			title: "FinTech and InsurTech company novae launches alle2020",
  			description: "In partnership with novae, Visa Loyalty Solutions has made it easier than ever to earn and redeem points with Visa, enabling consumers to exchange loyalty points anytime, anywhere and from any device.",
  			link: 'http://www.tynmagazine.com/fintech-and-insurtech-company-novae-launches-alle2020/',
        delay: '0ms'
  		},
  		{
  			img: './assets/img/cryptmi/itempress-21.png',
  			date: 'Mar 20, 2019',
  			title: "Borgun, one of Europe's advanced payment processors, signs an agreement with fintech and insurtech company novae to power its digital transformation",
  			description: "novae and Borgun to co-create solutions to expand and improve payment and loyalty options for banks and merchants while enhancing the customer experience",
  			link: 'https://www.prnewswire.co.uk/news-releases/borgun-one-of-europe-s-advanced-payment-processors-signs-an-agreement-with-fintech-and-insurtech-company-novae-to-power-its-digital-transformation-840123992.html',
        delay: '100ms'
  		}
  	]

    this.partners = [
      {
        main_title: 'Delayed flight?',
        description: '<strong>We’ll proactively compensate you for your flight delay</strong>. Just reach out to <strong>alle</strong> and, after some basic questions, instant compensation will be issued to your <strong>Miles Care Visa Digital Card</strong> to cover any cancellation costs.*',
        link: sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/437277140?loop=1&autopause=0'),
        class: 'text-right',
        animation: 'bounceInRight',
        animation2: 'bounceInLeft'
      },
      {
        main_title: 'Feeling sick?',
        description: 'From bad shrimp to bad skiing, <strong>alle will connect you to an open-access network of physicians</strong> by chat, phone, videoconference, or in person, so you can enjoy yourself without ever holding back.*',
        link: sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/414332967?loop=1&autopause=0'),
        class: 'text-left',
        animation: 'bounceInLeft',
        animation2: 'bounceInRight'
      },
      {
        main_title: 'Lost bag?',
        description: 'Contact us on the app and before you leave the airport, <strong>alle will automatically issue compensation</strong> to your <strong>Miles Care Visa Digital Card</strong>. That way you can shop for some essentials.*',
        link: sanitizer.bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/437234943?loop=1&autopause=0'),
        class: 'text-right',
        animation: 'bounceInRight',
        animation2: 'bounceInLeft'
      }
    ];
  }

  ngOnInit(): void {
    const t = 'gennius.xyz - Building Human-to-Human technologies';
    this.title.setTitle(t);

    this.seo.generateTags({
      title: 'gennius.xyz - Building Human-to-Human technologies',
      keyword: 'rewards, cryptocurrencies, crypto, cashback, points, miles, digital card, digital payment, loyalty rewards, redemptions, digital assets, bank cards, bank directs, smart payments, virtual card, metaverse, NFT',
      // tslint:disable-next-line:max-line-length
      description: 'Empowering rewards and Web3 platforms to create superior user experiences and bring digital engagement and loyalty to new levels.'
    });

  }
}
